import type { MeetingHome, MeetingItem } from '@/api/meetings';

export interface ItemAddress {
  /** The meeting's home: its virtual account, or null for a standalone meeting (MM-D-150). */
  virtualAccountId: MeetingHome;
  meetingId: number;
  occurrenceKey: string;
}

/** Build the occurrence address from the item's own `meetingId` + `occurrenceKey`. */
export function resolveItemAddress(item: MeetingItem): ItemAddress {
  return {
    virtualAccountId: item.virtualAccountId,
    meetingId: item.meetingId,
    occurrenceKey: item.occurrenceKey,
  };
}
